import { useEffect, useState } from "react"

// True once the element comes within `margin` of the scroller, and stays true.
const useNearScroll = (ref, rootRef, { initial = false, force = false, margin = "1500px" } = {}) => {
  const [near, setNear] = useState(initial)
  if (force && !near) setNear(true)

  useEffect(() => {
    if (near) return undefined
    const element = ref.current
    if (!element || typeof IntersectionObserver === "undefined") { setNear(true); return undefined }
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) setNear(true)
    }, { root: rootRef?.current || null, rootMargin: `${margin} 0px` })
    observer.observe(element)
    return () => observer.disconnect()
  }, [near, ref, rootRef, margin])

  return near
}

export default useNearScroll
